export default {
    home: '/',
    register: '/register',
    login: '/login',
    logout: '/logout',
    shows: '/shows',
    showDetails: '/shows/:showId',
    movies: '/movies',
    MovieDetailsPage: '/movies/:movieId',
}